import { useEffect } from 'react';
import { SigningInSpinner } from '~src/app/spaces/Login/SigningInSpinner';
import { AuthenticationService } from '~src/authentication/services/AuthenticationService';
import { AuthenticationType } from '~src/settings/types/IServerSettingsUnauthenticated';
import { RootLoginUiProps } from './RootLoginUi';
import React = require('react');

export interface AutoLoginProps extends RootLoginUiProps {
    serverAuthType: AuthenticationType;
    onFailedAutoLogin: (errorCode: number) => void;
}

export function AutoLogin(props: AutoLoginProps) {
    useEffect(() => {
        AuthenticationService.autoLogin(props.signinQueryParams)
            .then(() => AuthenticationService.redirectAfterSuccessfulLogin(props.signinQueryParams),
                props.onFailedAutoLogin);
    }, []);

    return <SigningInSpinner />;
}
